import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

const StyledGridInnerContainer = styled(Grid)(({ theme }) => ({
  width: '100%',
  height: '100%',
  minHeight: '90vh',
  flexWrap: 'nowrap',
  overflow: 'auto',
  position: 'relative',
  maxWidth: '768px',
  minWidth: '320px',
  [theme.breakpoints.up(475)]: {
    marginTop: '50px',
    marginBottom: '50px',
    border: '1px solid #CBCCCD',
    borderRadius: theme.shape.borderRadius,
  },
}));

export default StyledGridInnerContainer;
